export default {
	button: 'More details',
	description:
		'Buy {purchaseThreshold} or more vehicles between 17th November and 17th December to get {percentageDiscount}% off your fees for all vehicles purchased in that period.',
	modal: {
		buttonText: 'Got it',
		example: {
			discountApplied: '{percentageDiscount}% fee discount',
			discountAppliedTotal: '{totalSavings}',
			example: 'Example',
			totalSaving: 'Total saving',
			totalSavingAmount: '{totalSavings}',
			vehiclePurchases: 'Fees for {purchaseThreshold} vehicles',
			vehiclePurchasesTotal: '{feesOnThresholdVehicles}',
		},
		header: 'Buy more, pay less',
		howItWorks: {
			one: '1',
			step1: 'Buy _{purchaseThreshold}_ or more vehicles during the promotional period ',
			step2:
				'Once paid, get _{percentageDiscount}%_ off the vehicle fees, returned to you in the form of account credit',
			title: 'How it works',
			two: '2',
		},
		infoBox: {
			description: `Buy {purchaseThreshold} or more vehicles between 17th November and 17th December to get {percentageDiscount}% off your fees for all vehicles purchased in that period.`,
			title: 'Get {percentageDiscount}% off your total purchases',
		},
	},
	title: 'Get {percentageDiscount}% off your vehicle fees',
};
